import React from 'react'
import { Route, RouteProps as ReactRouteProps } from 'react-router-dom'

import { ColorVariables, LayerStyles, TextStyles, Symbols } from './pages'

import {
  getAllTemplatesForVersionedRoute,
  useFlag,
} from '@sketch/modules-common'
import ComponentsEmptyState from '../components/ComponentsEmptyState'
import { useGetComponentsCount } from './operations'

interface CwvRoutesProps extends ReactRouteProps {
  userIsEditor: boolean
}

export const CwvRoutes: React.FC<CwvRoutesProps> = ({ userIsEditor }) => {
  // TODO: Remove FF when released
  // https://github.com/sketch-hq/Cloud/issues/17734
  const isComponentsOnDemandOn = useFlag('component-ingest-on-demand')

  const { totalComponents } = useGetComponentsCount()

  if (isComponentsOnDemandOn) {
    if (totalComponents === 0) {
      return <ComponentsEmptyState userIsEditor={userIsEditor} />
    }
  }

  return (
    <>
      <Route exact path={getAllTemplatesForVersionedRoute('CWV_SYMBOLS')}>
        <Symbols />
      </Route>
      <Route exact path={getAllTemplatesForVersionedRoute('CWV_TEXT_STYLES')}>
        <TextStyles />
      </Route>
      <Route exact path={getAllTemplatesForVersionedRoute('CWV_LAYER_STYLES')}>
        <LayerStyles />
      </Route>
      <Route
        exact
        path={getAllTemplatesForVersionedRoute('CWV_COLOR_VARIABLES')}
      >
        <ColorVariables />
      </Route>
    </>
  )
}
